import { section, color, align } from '@settings/common';

// Default products with color and size
const defaultProducts = [
  {
    product: {
      handle: 'toddy-16oz-onyx-leopard',
      title: 'Toddy 16oz',
    },
    color: 'Onyx Leopard',
    size: '16 oz.',
  },
  {
    product: {
      handle: 'brumate-25oz-rehydration-bottle-onyx-leopard',
      title: 'BrüMate 25oz Rehydration Bottle',
    },
    color: 'Onyx Leopard',
    size: '25 oz.',
  },
];

export const Schema = () => {
  return {
    label: 'Product Carousel - Toggle',
    key: 'product-carousel-toggle',
    fields: [
      {
        label: 'Content Settings',
        name: 'content',
        component: 'group',
        fields: [
          {
            name: 'heading',
            label: 'Section Heading',
            component: 'text',
          },
          {
            name: 'headingAlign',
            label: 'Heading Alignment (Desktop)',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: align.options,
          },
          {
            name: 'headingAlignMobile',
            label: 'Heading Alignment (Mobile)',
            component: 'radio-group',
            variant: 'radio',
            direction: 'horizontal',
            options: align.options,
          },
          {
            name: 'togglesAlign',
            label: 'Toggles Alignment (Desktop)',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: align.options,
          },
          {
            name: 'togglesAlignMobile',
            label: 'Toggles Alignment (Mobile)',
            component: 'radio-group',
            variant: 'radio',
            direction: 'horizontal',
            options: align.options,
          },
        ],
        defaultValue: {
          heading: 'Shop By Color',
          headingAlign: align.value.left,
          headingAlignMobile: align.value.center,
          togglesAlign: align.value.center,
          togglesAlignMobile: align.value.center,
        },
      },
      {
        name: 'toggles',
        label: 'Toggle Options',
        component: 'group-list',
        itemProps: {
          label: '{{item.label}}',
        },
        fields: [
          {
            name: 'label',
            label: 'Toggle Label',
            component: 'text',
          },
          {
            name: 'products',
            label: 'Products',
            component: 'group-list',
            fields: [
              {
                name: 'product',
                component: 'productSearch',
                label: 'Select Product',
              },
              {
                name: 'color',
                label: 'Color',
                component: 'text',
                description:
                  'Enter the color name to display (e.g., "Onyx Leopard", "Matte Black")',
              },
              {
                name: 'size',
                label: 'Size (Optional)',
                component: 'text',
                description:
                  'Enter the size to display (e.g., "30 oz.", "40 oz.") - leave blank to hide',
              },
            ],
            defaultValue: defaultProducts,
          },
        ],
        defaultValue: [
          {
            label: '30 oz.',
            products: defaultProducts,
          },
          {
            label: '40 oz.',
            products: defaultProducts,
          },
        ],
      },
      {
        ...section,
        defaultValue: {
          bgColor: '#ffffff',
          color: '#000000',
          desktop: {
            container: 'container',
            mt: 'none',
            py: 'm',
          },
          mobile: {
            container: 'container',
            mt: 'none',
            py: 'm',
          },
        },
      },
    ],
  };
};
